export default "__VITE_ASSET__tDTY5MSf__"